import { render } from "./UpdateConfirmationModal.vue?vue&type=template&id=4d67e2eb"
import script from "./UpdateConfirmationModal.vue?vue&type=script&lang=js"
export * from "./UpdateConfirmationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__